// src/components/store/sections/blog-posts/BlogV83MinimaljournalSlateGold.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV83MinimaljournalSlateGold(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={83}
      archKey="minimal_journal"
      archLabel="Minimalist Journal Strip"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
